export MainMenu from './MainMenu';

export AppMenu from './Menus/AppMenu';
export UserMenu from './Menus/UserMenu';
export BlogsMenu from './Menus/BlogsMenu';
export PagesMenu from './Menus/PagesMenu';
export AssetsMenu from './Menus/AssetsMenu';



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/index.js